import { useState } from "react"

export const useOperationKeyValueFormHandling = () => {
    const [keyValueData, setKeyValueData] = useState({
    // key value information
    category: "",
    keyName: "",
    parentKeyId: "",
    code: "",
    active: true,

    // key value information status
    categoryStatus: "unchecked",
    keyNameStatus: "unchecked",
    parentKeyIdStatus: "unchecked",
    codeStatus: "unchecked",
    });
    

    const handleKeyValueDataChange = (event,selectEvent) => {
        let formState ={...keyValueData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){                

                case "category": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "parentKeyId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "keyName": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setKeyValueData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
            keyValueData.categoryStatus === "success" &&
            keyValueData.keyNameStatus === "success" &&
            keyValueData.codeStatus === "success"
        ) {
            allowSubmit = true;
        } else {
            allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        keyValueData,
        setKeyValueData,
        handleKeyValueDataChange,
        checkAllFields
    }
}